(function () {
var $ebf87f121a2730b1$var$newestArticlesAjax = {
    offset: 0,
    postsPerPage: 2,
    submitButton: null,
    container: null,
    loader: null,
    init: function() {
        var _this = this;
        var _this_submitButton;
        this.postsPerPage = document.querySelector('.newest-articles__posts').children.length;
        this.container = document.querySelector('.newest-articles__posts');
        this.loader = document.querySelector('.loader-container');
        this.alreadyAppearedPostIds = JSON.parse(document.querySelector('.newest-articles').getAttribute('data-already-appeared-post-ids'));
        this.submitButton = document.querySelector('.newest-articles__load-more');
        (_this_submitButton = this.submitButton) === null || _this_submitButton === void 0 ? void 0 : _this_submitButton.addEventListener('click', function() {
            return _this.submit();
        });
    },
    submit: function() {
        var _this = this;
        this.offset += this.postsPerPage;
        var data = new FormData();
        data.append('action', 'newest-articles');
        data.append('offset', this.offset);
        data.append('posts_per_page', this.postsPerPage);
        data.append('already_appeared_post_ids', JSON.stringify(this.alreadyAppearedPostIds));
        this.loader.classList.add('active');
        fetch(ajax.ajax_url, {
            method: 'POST',
            body: data
        }).then(function(res) {
            return res.json();
        }).then(function(data) {
            var response = data.data;
            var html = response.html, hasMore = response.hasMore;
            _this.container.insertAdjacentHTML('beforeend', html);
            if (!hasMore) _this.submitButton.classList.add('newest-articles__load-more--hidden');
            _this.loader.classList.remove('active');
        }).catch(function(err) {
            console.error(err);
        });
    }
};
document.addEventListener('DOMContentLoaded', function() {
    $ebf87f121a2730b1$var$newestArticlesAjax.init();
});

})();
//# sourceMappingURL=ajax.js.map
